import { useContext } from "react";
import { Link } from "react-router-dom";
import { TaskContext } from "../context/TaskContext";
import { HiOutlineClipboardCheck, HiOutlineCheckCircle, HiOutlineTrash, HiOutlinePencil } from "react-icons/hi";
import { useNavigate } from "react-router-dom";


function Home() {
  const { tasks, removeTask, completedTasks, completedTask } = useContext(TaskContext);
  const totalTasks = tasks.length + completedTasks.length;
  const navigate = useNavigate();

  return (
    <div className="container-home">
      <header>
        <div className="header-text">
          <h1>Lista de Tarefas</h1>
          <p>Organize seu dia e alcance seus objetivos com clareza.</p>
        </div>
        <Link className="btn-newTask" to="/add-task">
         <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0776 13.0083C10.0647 13.6366 8.86615 14 7.58169 14C3.94672 14 1 11.0899 1 7.5C1 3.91015 3.94672 1 7.58169 1C9.88894 1 11.9189 2.17248 13.094 3.94703" stroke="white" stroke-width="2"/>
<path d="M12.5361 8.76685V13.2287M10.1194 10.9978H14.9999" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M4.93213 5.7649L6.3137 8.26315C6.62176 8.8202 7.36498 8.95145 7.84521 8.53361L14.4142 2.81787" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>



 Adicionar Nova tarefa
        </Link>
      </header>
      <div className="dashboard">
        <div className="card pending">
          <div className="card-header">
            <div className="icon-header icon-pending">
              <HiOutlineClipboardCheck />
            </div>
            <h2>Tarefas Pendentes</h2>
          </div>
          <div className="card-body">
            {tasks.length === 0 ? 0 : tasks.length}
          </div>  
        </div>
        <div className="card completed">
          <div className="card-header">
            <div className="icon-header icon-completed">
              <HiOutlineCheckCircle />
            </div>
            <h2>Tarefas Concluídas</h2>
          </div>
          <div className="card-body">
            {completedTasks.length === 0 ? 0 : completedTasks.length}
          </div>  
        </div>
        <div className="card total">
          <div className="card-header">
            <div className="icon-header icon-total">
              <HiOutlineCheckCircle />
            </div>
            <h2>Tarefas Totais</h2>
          </div>
          <div className="card-body">
            {totalTasks === 0 ? 0 : totalTasks}
          </div>  
        </div>
      </div>

      <div className="task-list">
        <ul>
          {tasks.filter(task => task !== null).map((task) => (
            <li className="list-item" key={task.id}>
              <div className="icon-completed">
                <HiOutlineCheckCircle onClick={() => completedTask(task)} />
              </div>
              <div className="task-title">{task.title}</div>
              <div className="icons-actions">
                <HiOutlinePencil onClick={() => navigate(`/add-task/${task.id}`)} />
                <HiOutlineTrash onClick={() => removeTask(task.id)} />
              </div>
            </li>
          ))}
        </ul>
      </div>
      
    </div>
  );
}

export default Home;